// extracted by mini-css-extract-plugin
export default {"questionsWrapper":"show_interest_questions-module___questionsWrapper___b8b4fbac","questionText":"show_interest_questions-module___questionText___fd1540c9"};